import { ApiErrorCode, withApiErrorHandler } from '@/modules/common/api/errors';
import { axiosInstance } from '@/utils/axios';

import { CreateRequestedIntegrationsRequest } from '../types/request/requested-integrations';

/**
 * Submits a request for new integrations that are not currently available.
 * @param integrations - Array of integration names or links requested by the user
 */
export const createRequestedIntegrations = async (
  integrations: CreateRequestedIntegrationsRequest
): Promise<void> => {
  const endpoint = '/api/requested-integrations';

  await withApiErrorHandler(endpoint, ApiErrorCode.REQUESTED_INTEGRATIONS_CREATE_FAILED, () =>
    axiosInstance.post(endpoint, integrations)
  );
};
